import template from 'lodash/template';
// import templateSettings from "lodash/templateSettings";

export const getTemplateString = (str: string) => {
  // String which should be interpolated is inside '{}' brackets
  // template.templateSettings.interpolate = /{([\s\S]+?)}/g;
  if (str && typeof str === 'string') {
    const formattedString = str.replaceAll('{', '<%=').replaceAll('}', '%>');
    return template(formattedString);
  }
  return undefined;
};

export const isNullOrWhiteSpace = (input: any) => {
  return !input || !input.trim();
};

export const capitalizeFirstLetter = (str: string) => {
  return (str || '').charAt(0).toUpperCase() + (str || '').slice(1);
};
